import { classes } from 'html-classes';
import { observer } from 'mobx-react-lite';
import { type FC, useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { company, DEFAULT_COMPANIES } from '~/company/Company';
import { cartStore, checkoutStore } from '~/stores';

import styles from './CashPayment2.module.scss';

const banknotes = [100, 200, 500, 1000];

export const CashPayment2: FC = observer(() => {
  const { t } = useTranslation();
  const inputValue = useMemo(
    () =>
      checkoutStore.hasExactAmount
        ? t('prepareExactAmount')
        : checkoutStore.changeFromAmount || undefined,
    [checkoutStore.hasExactAmount, checkoutStore.changeFromAmount, t],
  );

  useEffect(() => {
    return () => checkoutStore.setChangeFromAmount(null);
  }, []);

  if (DEFAULT_COMPANIES.includes(company.name)) {
    return null;
  }

  return (
    <div className={styles.cashPayment}>
      <h3 className={styles.title}>{t('cashOrderTitle')}</h3>
      <p className={styles.subtitle}>{t('cashOrderDescription')}</p>
      <label className={styles.inputField}>
        <input
          data-input="enter-amount"
          type={checkoutStore.hasExactAmount ? 'text' : 'number'}
          disabled={checkoutStore.hasExactAmount}
          placeholder={t('enterYourAmount')}
          className={styles.input}
          value={inputValue}
          onChange={(event) =>
            checkoutStore.setChangeFromAmount(event.target.valueAsNumber)
          }
        />
        {checkoutStore.hasExactAmount ? null : company.currency}
      </label>
      <div className={styles.buttons}>
        <button
          data-button={cartStore.totalCartPrice.paid}
          key={cartStore.totalCartPrice.paid}
          className={classes([
            'button',
            styles.button,
            checkoutStore.hasExactAmount && styles.selected,
          ])}
          onClick={() =>
            checkoutStore.setHasExactAmount(!checkoutStore.hasExactAmount)
          }
        >
          {t('prepareExactAmount')}
        </button>
        {banknotes.map((value) => {
          return (
            <button
              data-button={value}
              key={value}
              className={classes([
                'button',
                styles.button,
                checkoutStore.changeFromAmount === value && styles.selected,
              ])}
              onClick={() => checkoutStore.setChangeFromAmount(value)}
            >
              {value} {company.currency}
            </button>
          );
        })}
      </div>

      {/* <div className={styles.checkbox}>
        <label className={classes(['control__checkbox', styles.checkbox])}>
          <input
            data-checkbox="exact-amount"
            type="checkbox"
            className="control__checkbox-input"
            checked={checkoutStore.hasExactAmount}
            onChange={() =>
              checkoutStore.setHasExactAmount(!checkoutStore.hasExactAmount)
            }
          />
          <span className="control__checkbox-mark" />
          {t('cashOrderExactAmount')}
        </label>
      </div> */}
      {/* {!checkoutStore.hasExactAmount && (
        <>
          <p className={styles.subtitle}>{t('cashOrderSelectBanknote')}</p>
          
          <p className={styles.subtitle}>{t('cashOrderEnterAmount')}</p>
          
        </>
      )} */}
    </div>
  );
});
